module.exports = __webpack_public_path__ + "static/media/bg-desk-creature-4.75a3c906.svg";